import axios from "axios";
import configuration from "../configs/configuration";
import { config } from "../configs/api";

export function authenticateUser(code: string) {
  return axios.get(`${configuration.apiBaseUrl}/auth/token?code=${code}`)
}

export function userLogout() {
  return axios.get(`${configuration.apiBaseUrl}/auth/logout`, config())
}

export function authorizeDropboxUser(userId: string, code: string) {
  return axios.get(`${configuration.apiBaseUrl}/dropbox/auth/token?code=${code}&user_id=${userId}`)
}

export function authorizeGoogleUser(userId: string, code: string) {
  return axios.get(`${configuration.apiBaseUrl}/google/auth/token?code=${code}&user_id=${userId}`)
}

export function getGoogleAuth(userId: string) {
  return axios.get(`${configuration.apiBaseUrl}/google/auth/${userId}`)
}

export function getDropboxAuth(userId: string) {
  return axios.get(`${configuration.apiBaseUrl}/dropbox/auth/${userId}`)
}

export function revokeGoogleUser(payload: { user_id: string | number, token: string }) {
  return axios.post(`${configuration.apiBaseUrl}/google/revoke/token`, payload)
}

export function revokeDropboxUser(payload: { user_id: string | number, token: string }) {
  return axios.post(`${configuration.apiBaseUrl}/dropbox/revoke/token`, payload)
}
export function isLoggedIn() {
  const user = localStorage.getItem('user')
  const userId = localStorage.getItem('userId')
  const bearer = localStorage.getItem('bearer')
  if (user && userId && bearer) {
    return true
  }
  return false
}
